import http from '@/core/http'
// import { map } from 'lodash'

const state = {
  itens: [],
  itensVariation: {},
  itensCards: [],
  campanhas: [],
  listaCampanhas: [],
  itensVisits: [],
  totalItens: 0,
  comissoesPrevistas: {
    recCJRCasino: 0,
    recCJRProg: 0,
    recNGRCasino: 0,
    recNGRProg: 0,
    cpa: 0,
  },
  visitasSeries: [],
  visitasCategories: [],
  qftdCpaSeries: [],
  qftdCpaCategories: [],
  subAffiliatesSeries: [],
  subAffiliatesCategories: [],
  revShareSeries: [],
  revShareCategories: [],
  adjustments: [],
}
const headers = { moduloname: 'afiliados' }

const actions = {
  getDashBoard: async ({commit}, payload) => {
    const result = await http.get('afiliados-painel', { params: payload, headers })
    commit('LISTA_DASHBOARD', result.data)
    return Promise.resolve(result.data.resultMap)
  },
  getCampanhas: async ({commit}, payload) => {
    const result = await http.get('campanha-afiliado', { params: payload, headers })
    commit('LISTA_CAMPANHAS', result.data)
    return Promise.resolve(result)
  },
  getDadosVisitas: async ({commit}, payload) => {
    const result = await http.get('dados-visitas', { params: payload, headers })
    commit('LISTA_VISITAS', result.data)
    return Promise.resolve(result)
  },
  getComissaoPrevistas: async ({commit}, payload) => {
    const result = await http.get('afiliados/comissao-previsto', { params: payload, headers })
    commit('LISTA_COMISSOES_PREVISTAS', result.data)
    return Promise.resolve(result)
  },
  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  }
}

const mutations = {
  'LISTA_DASHBOARD' (state, payload) {
    state.itens = payload.resultMap
    state.itensVariation = payload.resultMapVariation || {}
    state.itensCards = payload.resultMapCards
    // state.itensVisits = payload.resultMapClicks
    // state.listaCampanhas = payload.resultMapCampaign
    state.visitasSeries         = payload.visitasSeries         || []
    state.visitasCategories     = payload.visitasCategories     || []
    state.qftdCpaSeries         = payload.qftdCpaSeries         || []
    state.qftdCpaCategories     = payload.qftdCpaCategories     || []
    state.subAffiliatesSeries       = payload.subAffiliatesSeries       || []
    state.subAffiliatesCategories   = payload.subAffiliatesCategories   || []
    state.revShareSeries        = payload.revShareSeries        || []
    state.revShareCategories    = payload.revShareCategories    || []
    state.adjustments           = payload.adjustments           || []
  },
  'LISTA_VISITAS' (state, payload) {
    state.itensVisits = payload.resultMapClicks
    // state.listaCampanhas = payload.resultMapCampaign
  },
  'LISTA_CAMPANHAS' (state, payload) {
    state.listaCampanhas = payload.resultMapCampaign
  },
  'LIMPAR_ITEM' (state) {
    state.itens = [{}]
  },
  'LISTA_COMISSOES_PREVISTAS' (state, payload) {
    state.comissoesPrevistas = payload.resultMap
  },
}

const getters = {
  listaItens: state => state.itens,
  listaItensVariation: state => state.itensVariation,
  listaItensCards: state => state.itensCards,
  // listaCampanhas: state => state.campanhas,
  listaVisitas: state => state.itensVisits,
  totalItens: state => state.totalItens,
  comissoesPrevistas: state => state.comissoesPrevistas,
  listaCampanhas: state => state.listaCampanhas,
  listCampanhasSelect: state => [{ text: 'Todos', value: null }, ...state.itensVisits.map(it => ({ text: it.name, value: it.id }))],
  visitasSeries: state => state.visitasSeries,
  visitasCategories: state => state.visitasCategories,
  qftdCpaSeries: state => state.qftdCpaSeries,
  qftdCpaCategories: state => state.qftdCpaCategories,
  subAffiliatesSeries: state => state.subAffiliatesSeries,
  subAffiliatesCategories: state => state.subAffiliatesCategories,
  revShareSeries: state => state.revShareSeries,
  revShareCategories: state => state.revShareCategories,
  adjustments: state => state.adjustments,
}
export default { namespaced: true, state, actions, mutations, getters }